import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { APP_INITIALIZER } from '@angular/core';
import { MomentModule } from 'angular2-moment';
import { HttpClientModule } from '@angular/common/http';
import { Http } from '@angular/http';
import { MapsModule } from './views/maps/maps.module';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule, AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireDatabaseModule, AngularFireDatabase } from "angularfire2/database";
import { AngularFireAuthModule } from "angularfire2/auth";

import { setConfig, setHttp } from '../../models/data.model';

import { UsersService } from '../../models/usuarios.service';


import { DadosModule } from "../../models/dados.module";

import { DadosService } from "./db/dados.service";

import { environment } from '../environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

//import { AgmCoreModule } from '@agm/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true
};
import { CalendarModule } from 'angular-calendar';
import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { routing } from './app.routing';
import { ControlsModule } from './controls/controls.module';
import { ServicesModule } from './services/services.module';


import { AppComponent } from './app.component';
import { PagesComponent } from './views/pages/pages.component';
import { BlankComponent } from './views/blank/blank.component';
import { SearchComponent } from './views/search/search.component';
import { NotFoundComponent } from './views/errors/not-found/not-found.component';
import { ErrorComponent } from './views/errors/error/error.component';
import { AppSettings } from './app.settings';

import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { ViewsModule } from "./views/views.module";
import { FollowupModule } from "./followup/followup.module";
import { SidenavChatComponent } from './nav/sidenav-chat/sidenav-chat.component';

import { SugestoesComponent } from './views/sugestoes/sugestoes';
import { MatVertGrid } from '../../comum/controls/mat-vert-grid';

import { MatContainerModule } from '../../comum/controls/mat-container';
import { CustomDialogModule } from '../../comum/custom-dialog.module';
import { MessagingService } from '../../comum/services/push-notification-service';
import { NotificationsService,SimpleNotificationsModule } from 'angular2-notifications';

setConfig(environment);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MomentModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    DadosModule.forRoot({ prefix: environment.db_prefix }), // indica o prefixo das coleções.
    //AngularFirestoreModule,
    AngularFirestoreModule.enablePersistence(),  // off-line
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    /*AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }),*/
    PerfectScrollbarModule,
    CalendarModule.forRoot(),
    //UsersModule,
    SharedModule,
    PipesModule,
    routing,
    ServicesModule,
    ViewsModule,
    MapsModule,
    FollowupModule,
    ControlsModule,
    MatContainerModule,
    CustomDialogModule,
    SimpleNotificationsModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    BlankComponent,
    SearchComponent,
    NotFoundComponent,
    ErrorComponent,
    SidenavComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    FlagsMenuComponent,
    FullScreenComponent,
    ApplicationsComponent,
    MessagesComponent,
    UserMenuComponent,
    SidenavChatComponent,
    SugestoesComponent,
    MatVertGrid,
  ],
  exports: [
    SugestoesComponent,
  ],
  entryComponents: [
  ],
  providers: [
    MessagingService,
    NotificationsService,
    DadosService,
    UsersService,
    {
      provide: APP_INITIALIZER,
      useFactory: (ds: DadosService) => function () { return ds.init() },
      deps: [DadosService],
      multi: true
    },
    AppSettings,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: OverlayContainer, useClass: CustomOverlayContainer }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})



export class AppModule {
  static http: Http;
  constructor(http: Http, private firestore: AngularFirestore) {
    AppModule.http = http;
    setHttp(http);
  }

  

}

